import { ExcelGridColumn, ExcelGridRow } from "../../shared/excel-grid/models/excel-grid.models";

export type AdminBqTqFormType = "TECH_FORM" | "BALTIC_QUESTIONNAIRE";

/**
 * API response row for the admin BQ/TQ navigator backed by Snowflake submission tables.
 */
export interface AdminBqTqFormResponseRow {
  FORM_TYPE: AdminBqTqFormType;
  REQUESTED_BY_USER: string | null;
  VESSEL_CODE: string | null;
  VESSEL_NAME: string | null;
  IMO_NUMBER: string | null;
  VESSEL_MASTER_EMAIL: string | null;
  TCCODE: string | null;
  SUBMIT_STATUS: string | null;
  SUBMITTED_ON: string | null;
  REQUESTED_ON: string | null;
  SUBMITTED_VIA: string | null;
  SUBMITTED_BY_EMAIL: boolean | null;
}

export interface AdminBqTqFormGridRow extends ExcelGridRow {
  formType: string;
  vesselName: string;
  imoNumber: string;
  vesselCode: string;
  vesselMasterEmail: string;
  status: string;
  requestedOn: string;
  submittedOn: string;
  submittedVia: string;
  submittedByEmail: string;
  tcCode: string;
}

export const ADMIN_BQ_TQ_FORM_COLUMNS: ExcelGridColumn[] = [
  { key: "formType", label: "Form", editable: false, filterable: true, sortable: true, minWidth: 160 },
  { key: "vesselName", label: "Vessel", editable: false, filterable: true, sortable: true, minWidth: 220 },
  { key: "imoNumber", label: "IMO", editable: false, filterable: true, sortable: true, minWidth: 110 },
  { key: "vesselCode", label: "Vessel Code", editable: false, filterable: true, sortable: true, minWidth: 130 },
  {
    key: "vesselMasterEmail",
    label: "Vessel Master",
    editable: false,
    filterable: true,
    sortable: true,
    minWidth: 260,
  },
  { key: "status", label: "Status", editable: false, filterable: true, sortable: true, minWidth: 130 },
  {
    key: "submittedVia",
    label: "Submitted Via",
    editable: false,
    filterable: true,
    sortable: true,
    minWidth: 170,
  },
  { key: "submittedByEmail", label: "Submitted By Email", editable: false, filterable: true, sortable: true, minWidth: 170 },
  { key: "tcCode", label: "TC Code", editable: false, filterable: true, sortable: true, minWidth: 120 },
  { key: "requestedOn", label: "Requested", editable: false, filterable: true, sortable: true, minWidth: 180 },
  { key: "submittedOn", label: "Submitted", editable: false, filterable: true, sortable: true, minWidth: 180 },
];
